import { BaseDto } from './base-dto';

export class CompanyDto extends BaseDto {
	id!: string;
	name!: string;
}
